import { useState, useCallback, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import useGet from '../../../hooks/useGet';
import { PAGE_CONFIG } from '../config';
import api from '../../../api';

export const useTimelineData = () => {
    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: ''
    });
    const [searchQuery, setSearchQuery] = useState('');

    const { data, pagination, isLoading, refetch } = useGet(
        PAGE_CONFIG.GET_QUERY_KEY,
        () => api.timeline.getTimeline(params),
        PAGE_CONFIG.DEFAULT_ERROR_MESSAGE,
        PAGE_CONFIG.SELECT,
        params
    );

    // Handle page change
    const handlePageChange = useCallback((newPage) => {
        if (newPage < 1) return;
        setParams((prev) => ({ ...prev, page: newPage }));
    }, []);

    const handlePageSizeChange = useCallback((limit) => {
        if (limit < 1) return;
        setParams((prev) => ({ ...prev, limit }));
    }, []);

    // Create a debounced search function
    const debouncedSearch = useMemo(
        () =>
            debounce((searchValue) => {
                setParams((prev) => ({ ...prev, search: searchValue, page: 1 }));
            }, 500),
        []
    );

    // Cleanup debounce on component unmount
    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, [debouncedSearch]);

    // Trigger refetch when params change
    useEffect(() => {
        refetch();
    }, [params, refetch]);

    const handleSearch = useCallback((value) => {
        setSearchQuery(value);
        debouncedSearch(value);
    }, [debouncedSearch]);

    return {
        data,
        pagination,
        isLoading,
        searchQuery,
        handlePageChange,
        handlePageSizeChange,
        handleSearch
    };
}; 